export const getColumns = (columns?: string | null): string => columns ?? "1fr";
